import React from 'react';

import LookupPicker from '../additional_payments/lookup_picker';
import { fetch_additional_teachers } from '../api';

/*
 * PROD-7828 — the teacher filter every Teacher Payments page can use: a typeahead on
 * GET /additional/teachers_lookup?q= (matches name/email/slug/uuid, min 2 chars), the same picker the
 * Add-penalty dialogs use for a teacher field. Props-only: the host owns the chosen teacher and its URL
 * persistence; this only searches and reports a pick or a clear.
 * value: { teacher_uuid, display } — display is the name shown once picked; '' / '' = nothing chosen.
 * onChange(next): next is { teacher_uuid, display }, or { teacher_uuid: '', display: '' } on clear.
 */
const search_teachers = (q) =>
  fetch_additional_teachers(q).then((d) => (Array.isArray(d.rows) ? d.rows : []));

const TeacherFilter = ({
  id = 'tp-teacher-filter',
  label = 'Filter by teacher',
  label_hidden = true,
  placeholder = 'Filter by name, slug or email',
  value,
  onChange
}) => (
  <LookupPicker
    id={id}
    name="teacher filter"
    label={label}
    label_hidden={label_hidden}
    placeholder={placeholder}
    min_chars={2}
    value_text={value.display}
    search={search_teachers}
    option_key={(t) => t.teacher_uuid}
    render_option={(t) => (
      <span>
        <b>{t.name}</b> · {t.email}
      </span>
    )}
    on_pick={(t) => onChange({ teacher_uuid: t.teacher_uuid, display: t.name })}
    on_clear={() => onChange({ teacher_uuid: '', display: '' })}
  />
);

export default TeacherFilter;
